import React from 'react';
import classNames from 'classnames';
import { withRouter, matchPath } from 'react-router-dom';
import { connect } from 'react-redux';
import Typist from 'react-typist';


const Screensaver = props => {
  const { screensavers, active } = props;
  const hideScreensaver = matchPath(props.location.pathname, {
    path: '/directors/:slug/:id',
    exact: true
  });

  if(hideScreensaver || screensavers.length < 1){
    return false;
  }

  const randomIndex = Math.floor(Math.random() * screensavers.length);
  const screensaver = screensavers[randomIndex];

  return <div className={classNames('screensaver', {
      'screensaver--active': active
    })} >
    <div className="screensaver__wrapper">
      <div className="screensaver__image" style={{backgroundImage: `url(${screensaver.image.url})`}} />
      <div className="screensaver__container">
        <div className="screensaver__title">
          {screensaver.title}
        </div>
        <div className="screensaver__content">
          {active &&
            <Typist
              startDelay={1200}
              avgTypingDelay={75}
              stdTypingDelay={50}
              cursor={{
                show: true,
                blink: true,
                element: '_',
                hideWhenDone: false,
              }}
              >
              {screensaver.content}
              <Typist.Delay ms={300} />
              <span> #akkurat</span>
              <Typist.Backspace count={8} delay={200} />
              <span className="highlight"> #akkurat</span>
            </Typist>
          }
        </div>
      </div>
    </div>
  </div>
}

const mapStateToProps = state => {
  const { screensavers } = state;

  return {
    screensavers: screensavers.screensavers
  }
}

export default withRouter(connect(mapStateToProps, null)(Screensaver));
